import Swiper from 'swiper';
import { Pagination, Navigation, EffectFade, Thumbs, A11y, Autoplay } from 'swiper/modules';
import { classes, config } from './Constants';
import ADA from './ADA';
import APIVideo from './APIVideo';
import ControlVideo from './controlVideo';
import { uuidv4, getKalturaVideoId } from '../../utils';

export default class SwiperSlider {
  constructor(el, $btnControl, $btnControlSound) {
    this.$el = $(el);
    this.classes = classes;
    this.config = config;
    this.timeOut = null;
    this.dom = {
      $swiperBanner: this.$el.find(`.${this.classes.swiperBanner}`),
      $bannerItem: this.$el.find(`.${this.classes.swiperBanner} .${this.classes.bannerItem}`),
      $buttonControlVideo: this.$el.find(`.${this.classes.controlVideo}`),
      $bannerContentItem: this.$el.find(`.${this.classes.swiperBannerContent} .${this.classes.bannerItem}`),
      $btnControls: $btnControl,
      $btnControlSounds: $btnControlSound,
    };

    this.index = 1;
    this.checkLazyIframe = false;
    this.lengthItem = this.dom.$bannerItem.length;
    this.ADA = new ADA(el);
    this.ControlVideo = new ControlVideo(el);
    this.callAPIVideo = new APIVideo(el);
    this.muteHiddenVideo = 'mute-hidden-video';
  }

  addListener() {
    if (this.isLengthItemGreaterThanOne()) {
      this.$el.on('mouseover', `.${this.classes.wrapSwiperButtonRight}`, this.mouseOvertRightEvent.bind(this));
      this.$el.on('mouseout', `.${this.classes.wrapSwiperButtonRight}`, this.mouseOutRightEvent.bind(this));
      this.$el.on('mouseover', `.${this.classes.wrapSwiperButtonLeft}`, this.mouseOvertLeftEvent.bind(this));
      this.$el.on('mouseout', `.${this.classes.wrapSwiperButtonLeft}`, this.mouseOutLeftEvent.bind(this));
    }
  }

  keyBoardEvent() {
    this.$el.on('keydown', (e) => {
      if (e.keyCode === 39) {
        window.sliderBannerContent.slideNext();
        setTimeout(() => {
          $(`.${this.classes.swiperBannerContent} .${this.classes.swiperButtonNext}`).focus();
        }, 300);
      }
      if (e.keyCode === 37) {
        window.sliderBannerContent.slidePrev();
        setTimeout(() => {
          $(`.${this.classes.swiperBannerContent} .${this.classes.swiperButtonPrev}`).focus();
        }, 300);
      }
    });
  };

  replaceHeadlinesWithDiv($element) {
    $element.find('h1,h2,h3,h4,h5,h6').each((_index, element) => {
      const $headline = $(element);
      $headline.replaceWith($('<div/>').addClass('h1').html($headline.html()));
    });
  };

  cloneBannerItemSlide() {
    if (this.isLengthItemGreaterThanOne()) {
      this.dom.$bannerItem.last().addClass(this.classes.lastSlider).clone().addClass('clone-slide').addClass(this.classes.cloneItem).prependTo(`.${this.classes.swiperBanner} .${this.classes.swiperWrapper}`);
      const bannerFirstItemClone = this.dom.$bannerItem.eq(0).addClass(this.classes.firstSlider).clone().addClass('clone-slide');
      bannerFirstItemClone.find('img').removeAttr('fetchpriority');
      bannerFirstItemClone.appendTo(`.${this.classes.swiperBanner} .${this.classes.swiperWrapper}`);
      this.dom.$bannerContentItem.last().addClass(this.classes.lastSlider).clone().prependTo(`.${this.classes.swiperBannerContent} .${this.classes.swiperWrapper}`);
      this.dom.$bannerContentItem.eq(0).addClass(this.classes.firstSlider).clone().appendTo(`.${this.classes.swiperBannerContent} .${this.classes.swiperWrapper}`);
      this.dom.$bannerItem = this.dom.$swiperBanner.find(`.${this.classes.bannerItem}`);

      $(`.${this.classes.cloneItem}`).find('iframe').remove();

      const $bannerContentItemClone = this.$el.find(`.${this.classes.swiperBannerContent} .${this.classes.bannerItem}`);
      this.replaceHeadlinesWithDiv($bannerContentItemClone.eq(0));
      this.replaceHeadlinesWithDiv($bannerContentItemClone.last());
    }
  }

  isLengthItemGreaterThanOne() {
    return this.lengthItem > 1;
  }

  swiperSlider() {
    const sliderBanner = new Swiper(`.${this.classes.swiperBanner}`, {
      modules: [Thumbs, A11y],
      rewind: true,
      grabCursor: true,
      initialSlide: 1,
      watchSlidesProgress: true,
      speed: 500,
      allowTouchMove: false,
      on: {
        init: (e) => { this.initSwiperBannerImage(e); },
        slideChange: (e) => { this.timeOutSwiperBannerImage(e); },
      },
    });
    window.sliderBanner = sliderBanner;
    const sliderBannerContent = new Swiper(`.${this.classes.swiperBannerContent}`, {
      modules: [Pagination, EffectFade, Thumbs, Navigation, A11y, Autoplay],
      rewind: true,
      grabCursor: false,
      allowTouchMove: true,
      watchSlidesProgress: true,
      initialSlide: 1,
      speed: 500,
      effect: 'fade',
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      pagination: {
        el: `.${this.classes.swiperBannerContent} .${this.classes.swiperPagination}`,
        clickable: true,
      },
      navigation: {
        nextEl: `.${this.classes.swiperBannerContent} .${this.classes.swiperButtonNext}`,
        prevEl: `.${this.classes.swiperBannerContent} .${this.classes.swiperButtonPrev}`,
      },
      thumbs: {
        swiper: sliderBanner,
      },
      on: {
        init: (e) => {
          const $elm = $(e.visibleSlides[0]);
          if ($elm.hasClass('hidden-mute')) {
            this.$el.addClass(this.muteHiddenVideo);
          }
          $( `<button class="button-handle-slide text-white mt-2p5"><span class="sr-only">handle slider</span> <span class="icomoon icon-pause text-base" aria-hidden="true"></span></button>` ).appendTo(`.${this.classes.swiperBannerContent} .${this.classes.swiperPagination}`);
          this.ADA.initADA();
          this.changeNumberBullet();
          this.clickHandleSlide();
        },
        transitionStart: (_e) => { $(`.${this.classes.wrapSwiperButton}`).addClass(this.classes.eventPointer); },
        transitionEnd: (e) => {
          this.transitionStartSwiperBannerContent(e);
          this.changeNumberBullet();
        },
      },
    });
    // handle api next slide apiVideo
    window.sliderBannerContent = sliderBannerContent;
    sliderBanner.on('slideChange', (e) => {
      this.slideChangeSwiperBannerImageBottom(e);
    });

    sliderBannerContent.on('slideChange', (e) => {
      const $elm = $(e.visibleSlides[0]);
      if ($elm.hasClass('hidden-mute')) {
        this.$el.addClass(this.muteHiddenVideo);
      } else {
        this.$el.removeClass(this.muteHiddenVideo);
      }
    });

    this.customControl(sliderBannerContent, sliderBanner);
    this.$el.addClass('set-animation');
  }

  clickHandleSlide() {
    const buttonHandleSlide = '.button-handle-slide';
    this.$el.on('click', buttonHandleSlide, () => {
      if (window.sliderBannerContent.autoplay.running) {
        window.sliderBannerContent.autoplay.stop();
        $(buttonHandleSlide).find('.icon-pause').removeClass('icon-pause').addClass('icon-play-2');
      } else {
        window.sliderBannerContent.autoplay.start();
        $(buttonHandleSlide).find('.icon-play-2').removeClass('icon-play-2').addClass('icon-pause');
      }
    });
  }

  changeNumberBullet () {
    const $bullet = $(`.${this.classes.swiperBannerContent}`).find('.swiper-pagination-bullet');
    const ariaLabel = 'aria-label';
    $bullet.each((i, el) => {
      $(el).attr(ariaLabel, `Go To Slide ${i}`);
      if (i === 0) {
        $(el).attr(ariaLabel, 'Go To Slide Clone');
      }
      if (i === $bullet.length - 1) {
        $(el).attr(ariaLabel, 'Go To Slide Clone');
      }
    });
  }

  initSwiperBannerImage(e) {
    if ($(e.visibleSlides[0]).find('.banner-bg-video').length > 0) {
      setTimeout(() => {
        this.setupInitFirst(0, $(e.visibleSlides[0]));
        this.dom.$buttonControlVideo.removeClass(this.classes.hidden);
      }, 500);
    }
    this.timeOutSwiperBannerImage(e);
  }

  timeOutSwiperBannerImage(e) {
    $(`.${this.classes.controlVideo}`).find('.btn-info').removeClass('show');
    $(`.${this.classes.controlVideo}`).find(`.btn-info-clone-${e.activeIndex + 1}`).addClass('show');
    if (e.activeIndex > 1 && this.checkLazyIframe === false) {
      this.setup();
      setTimeout(() => {
        window.listVideo.forEach((_elem, i) => {
          this.ControlVideo.handlePause(i);
        });
      }, 1000);
      this.checkLazyIframe = true;
    }
  }

  slideChangeSwiperBannerImageBottom(e) {
    const $elm = $(e.visibleSlides[0]);
    const $index = $elm.find(`.${this.classes.bannerBgVideo}`).attr(this.config.dataPlayer);
    window.listVideo.forEach((_elem, i) => {
      this.ControlVideo.handlePause(i);
    });

    if (!$elm.hasClass(this.classes.bgVideo)) {
      this.dom.$buttonControlVideo.addClass(this.classes.hidden);
    } else {
      this.dom.$buttonControlVideo.removeClass(this.classes.hidden);
    }

    if ($index && $index < this.lengthItem) {
      this.handlePausePlayVideoSwiperChange($elm, $index);
    }
    if ($elm.find('.declaimer-text').length > 0) {
      this.dom.$buttonControlVideo.find('.btn-info').addClass('opacity-0');
    } else {
      this.dom.$buttonControlVideo.find('.btn-info').removeClass('opacity-0');
    }

  }

  handlePausePlayVideoSwiperChange($elm, $index) {
    if (!$elm.hasClass(this.classes.pauseVideo)) {
      setTimeout(() => {
        this.ControlVideo.handlePlay(Number($index) - 1);
      }, 1000);
      if ($(window).innerWidth() > 1199) {
        if (window.mutedVideo === false) {
          this.ControlVideo.handleMute(Number($index) - 1);
          this.dom.$btnControlSounds.removeClass(this.classes.activeSound);
        } else {
          this.ControlVideo.handleUnMute(Number($index) - 1);
          this.dom.$btnControlSounds.addClass(this.classes.activeSound);
        }
      }
      /* eslint-disable-next-line */
      this.dom.$btnControls.find(`.${this.classes.textControl}`).text(typeof videoPauseTextHome === null ? '' : videoPauseTextHome);
      $elm.removeClass(this.classes.pauseVideo);
      this.dom.$btnControls.removeClass(this.classes.pause);
    } else {
      /* eslint-disable-next-line */
      this.dom.$btnControls.find(`.${this.classes.textControl}`).text(typeof videoPlayTextHome === null ? '' : videoPlayTextHome);
      this.dom.$btnControls.addClass(this.classes.pause);
    }

    this.checkIconSoundMobile($elm);
  }

  transitionStartSwiperBannerContent() {
    clearTimeout(this.timeOut);
    $(`.${this.classes.wrapSwiperButton}`).removeClass(this.classes.eventPointer);
  }

  checkIconSoundMobile($elm) {
    if ($(window).innerWidth() < 1200) {
      if (!$elm.hasClass(this.classes.activeSound)) {
        /* eslint-disable-next-line */
        this.dom.$btnControlSounds.removeClass(this.classes.activeSound)
      } else {
        /* eslint-disable-next-line */
        this.dom.$btnControlSounds.addClass(this.classes.activeSound)
      }
    }
  }

  customControl(swiper, swiperThumb) {
    swiper.on('slideChange', (_e) => {
      const $elm = $(swiper.slides[swiper.activeIndex]);
      setTimeout(() => {
        if (swiper.activeIndex === 0) {
          swiper.slideTo(swiper.slides.length - 2, 0, false);
          swiper.autoplay.start();
        }
        if (swiper.activeIndex === swiper.slides.length - 1) {
          swiperThumb.params.speed = 0;
          swiper.slideTo(1, 0, false);
          setTimeout(() => {
            swiperThumb.params.speed = 500;
            swiper.autoplay.start();
          }, 10);
        }
      }, 500);

      // ADA Keyboard
      this.ADA.setTabIndexNegativeForUnActiveSlide($elm);
      this.ADA.setTabIndexPositiveForActiveSlide($elm);
      this.ADA.disableTabindexDots();
    });
  }

  mouseOvertRightEvent(e) {
    const $swiperList = $(e.currentTarget).parents(this.$el).find(`.${this.classes.swiperBanner}`);
    $swiperList.addClass(this.classes.hoverNext);
  }

  mouseOutRightEvent() {
    $(`.${this.classes.hoverNext}`).removeClass(this.classes.hoverNext);
  }

  mouseOvertLeftEvent(e) {
    const $swiperList = $(e.currentTarget).parents(this.$el).find(`.${this.classes.swiperBanner}`);
    $swiperList.addClass(this.classes.hoverPrev);
  }

  mouseOutLeftEvent() {
    $(`.${this.classes.hoverPrev}`).removeClass(this.classes.hoverPrev);
  }

  setupInitFirst(i, el) {
    this.setPlayer(i, el);
  }

  isYouTubeAPIReady() {
    return typeof window.YT !== 'undefined' && typeof window.YT.Player !== 'undefined';
  }

  isVimeoAPIReady() {
    return typeof window.Vimeo !== 'undefined';
  }

  setPlayer(i, el) {
    const $iframe = $(el).find(`div.${this.classes.bannerBgVideo}`);
    if (!$iframe.parents('.clone-slide').length > 0 && $iframe.find('.kaltura-player-container').length === 0) {
      $iframe.attr('id', uuidv4());
      const $id = $iframe.attr('id');
      if ($iframe.length > 0) {
        const url = this.checkUrlVideo($iframe);
        if ((url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be') !== -1) && this.isYouTubeAPIReady()) {
          this.callAPIVideo.APIYoutube(el, $iframe, url, i, this.index);
        }
        if (url.toLowerCase().indexOf('vimeo.com') !== -1 && this.isVimeoAPIReady()) {
          this.callAPIVideo.APIVimeo(el, $iframe, url, i, this.index);
        }
        if (url.indexOf('kaltura.com') !== -1 && typeof KalturaPlayer !== 'undefined') {
          const idVideo = getKalturaVideoId(url);
          this.callAPIVideo.APIKaltura(idVideo, $id, url, this.index);
        }
        this.index++;
      }
    }
  }

  checkUrlVideo($iframe) {
    let url = $iframe.attr('data-src');
    if ($iframe.attr('data-src-mb')) {
      $iframe.addClass('mobile-style');
      if (window.innerWidth > 767) {
        url = $iframe.attr('data-src');
      } else {
        url = $iframe.attr('data-src-mb');
      }
    }
    return url;
  }

  setup() {
    this.dom.$bannerItem.each((i, el) => {
      this.setPlayer(i, el);
    });
  }
}